// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

const ProductImageOverlay = Styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(255, 255, 255, 0.7);
  justify-content: center;
  align-items: center;
  display: flex;
  font-family: Nunito;
  font-weight: 800;
  letter-spacing: normal;
  text-align: center;
  @media ${(props) => props.theme.mediaQuery.small} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: 24px;
  }
`;
export default ProductImageOverlay;
